module.exports = __webpack_public_path__ + "img/melio-logo-vector.37e7d604.svg";